import {Button, Stack} from "@mui/material";
import {openLoginDialog} from "../../../store/actions/loginDialogSlice";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../store/store";

export default function LoginSignupStack() {
  const dispatch = useDispatch<AppDispatch>();
  const handleLoginClick = () => {
    dispatch(openLoginDialog());
  };
  return (
    <Stack direction={"row"}>
      <Button variant="text" onClick={handleLoginClick}>
        Log in
      </Button>
      <Button variant="contained" disableElevation onClick={handleLoginClick}>
        Sign up
      </Button>
    </Stack>
  );
}
